<template>
  <div class="wrapper">
    <div>
      <div>
        <select
          class="form-control form-control-sm shadow-none col-md-2 mt5"
          v-model="zap_or_instr"
          @change="change_instr_or_zap"
        >
          <option value="zap">запчасти</option>
          <option value="instr">инструмент</option>
        </select>
      </div>
      <div>структура файла для загрузки</div>
      <table class="table table-sm table-bordered table-responsive">
        <tr>
          <td>код 1</td>
          <td>артикул 1</td>
          <td>наименование 1</td>
        </tr>
        <tr>
          <td>код 2</td>
          <td>артикул 2</td>
          <td>наименование 2</td>
        </tr>
        <tr>
          <td>код 3</td>
          <td>артикул 3</td>
          <td>наименование 3</td>
        </tr>
      </table>
      <button
        class="btn btn-sm btn-outline-primary shadow-none"
        @click="addFile"
      >
        выбрать файл
      </button>
      <input type="file" id="file" ref="file" @change="upload" />
      <div v-if="upload_data.length > 0">
        <table class="table table-sm table-bordered table-responsive">
          <thead>
            <tr>
              <th class="text-center" colspan="4">загружено</th>
            </tr>
            <tr>
              <th></th>
              <th>наименование</th>
              <th>код</th>
              <th>артикул</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in upload_data" :key="idx">
              <td>{{ idx + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.cod }}</td>
              <td>{{ item.art }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTPPOSTFILE } from "@/api";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "UploadInstrFromExcel",
  computed: {
    ...mapGetters(["USER_INFO", "ZAPORINSTR"]),
    zap_or_instr: {
      get() {
        return this.ZAPORINSTR;
      },
      set(value) {
        this.set_zap_or_instr(value);
      }
    }
  },
  data: () => ({
    upload_data: []
  }),
  methods: {
    ...mapMutations(["LOAD", "set_zap_or_instr"]),
    upload() {
      let url;
      url = "/admin/upload_instr_from_excel/upload.php";
      this.LOAD(true);
      let formData = new FormData();
      formData.append(`file`, this.$refs.file.files[0]);
      let data = {"zap_or_instr": this.ZAPORINSTR};
      data = JSON.stringify(data);
      formData.append("data", data);
      HTTPPOSTFILE({
        url: url,
        data: formData
      })
        .then((response) => (this.upload_data = response.data))
        .then(() => {
          document.getElementById("file").value = "";
          this.LOAD(false);
        });
    },
    addFile() {
      document.getElementById("file").value = "";
      const input = document.getElementById("file");
      input.click();
    },
    change_instr_or_zap() {
        console.log(this.ZAPORINSTR);
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 10px;
}
table {
  font-size: 0.7em;
}
th {
  text-align: center;
  vertical-align: middle;
}
td {
  vertical-align: middle;
}
#file {
  position: absolute;
  top: -10000px;
}
</style>